import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manage-reservation-tag';
const tagList = (systemSource, merchantId, branchId, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}`),
		data
	);
};

const addTag = (systemSource, merchantId, branchId, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}`),
		data
	);
};

const updateTag = (systemSource, merchantId, branchId, id, data) => {
	return Client.put(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}/${id}`),
		data
	);
};

export default {
	tagList,
	addTag,
	updateTag,
};
